import React from 'react';
import PropTypes from 'prop-types';

import PrintAssetForm from './PrintAssetForm';
import withModal from '../../../../../../../components/global/modal/withModal';

export const PRINT_ASSET_FORM_MODAL = 'MODAL/PRINT_ASSET_FORM';

const propTypes = {
  actionProps: PropTypes.shape({
    printAsset: PropTypes.shape({
      id: PropTypes.string,
    }),
    defaultPricingCategoryIds: PropTypes.array,
    defaultAssetImage: PropTypes.object,
    onPrintAssetCreate: PropTypes.func,
  }),
};

const PrintBackgroundAssetModal = ({ actionProps, ...props }) => {
  const {
    printAsset,
    printAssetType,
    defaultPricingCategoryIds = [],
    defaultAssetImage,
    onPrintAssetCreate,
  } = actionProps ?? {};

  return (
    <PrintAssetForm
      printAsset={printAsset}
      defaultPrintAssetType={printAssetType}
      defaultPricingCategoryIds={defaultPricingCategoryIds}
      defaultAssetImage={defaultAssetImage}
      onPrintAssetCreate={onPrintAssetCreate}
      {...props}
    />
  );
};

PrintBackgroundAssetModal.propTypes = propTypes;

export default withModal(PrintBackgroundAssetModal, {
  name: PRINT_ASSET_FORM_MODAL,
  size: 'sm',
  type: 'full',
});
